import { Link } from 'react-router-dom';

export default function Button({ to, href, children, variant = 'primary', className = '', ...props }) {
  const classes = `button button--${variant} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    const isExternal = href.startsWith('http') || href.startsWith('//');
    const relValue = isExternal ? 'noopener noreferrer' : undefined;
    const targetValue = isExternal ? '_blank' : undefined;

    return (
      <a
        href={href}
        className={classes}
        rel={props.rel || relValue}
        target={props.target || targetValue}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  );
}
